import { gql } from '@apollo/client';

export const INSERT_WILDCARDS = gql`
  mutation InsertWildcard($data: WildcardInput!) {
    createWildcard(data: $data) {
      data {
        attributes {
          title
          startDate
          endDate
          description
          status
        }
      }
    }
  }
`;

export const UPDATE_WILDCARDS = gql`
  mutation UpdateWildcard($id: ID!, $data: WildcardInput!) {
    updateWildcard(id: $id, data: $data) {
      data {
        attributes {
          title
          startDate
          endDate
          description
          status
        }
      }
    }
  }
`;

export const PUBLISH_WILDCARDS = gql`
  mutation PublishWildcard($id: ID!) {
    updateWildcard(id: $id, data: { status: PUBLISHED }) {
      data {
        attributes {
          status
        }
      }
    }
  }
`;

export const UNPUBLISH_WILDCARDS = gql`
  mutation UnpublishWildcard($id: ID!) {
    updateWildcard(id: $id, data: { status: DRAFT }) {
      data {
        attributes {
          status
        }
      }
    }
  }
`;

export const DELETE_WILDCARDS = gql`
  mutation DeleteWildcard($id: ID!) {
    updateWildcard(id: $id, data: { status: DELETED }) {
      data {
        attributes {
          status
        }
      }
    }
  }
`;
